import { apiPlugin, ApiPluginOptions, TitleMixin } from "@/shared";
import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import ElementPlus from "element-plus";
/**
 *
 */
import AppFormHolder from "./views/components/page-holder.vue";
import AppFormTitle from "./views/components/form-title.vue";
import AppCreateAccountLinks from "./views/components/create-account-links.vue";
import { RegisterGlobalComponents } from "@/shared/components";
import AppPasswordStrength from "@/shared/components/business-talent/other/password-strength.vue";

import VueGtag from "vue-gtag";
/**
 * Create the main app and attach the needed plugins and modules
 */
const app = createApp(App);
/**
 * Register global components
 */
RegisterGlobalComponents(app);
/**
 *
 */
app
  .use(store)
  .use(router)
  .use(apiPlugin, {
    apis: {
      main: process.env.VUE_APP_API_MAIN,
      admin: process.env.VUE_APP_API_ADMIN,
    },
  } as ApiPluginOptions)
  .mixin(TitleMixin)
  .component("app-form-holder", AppFormHolder)
  .component("app-form-title", AppFormTitle)
  .component("app-create-account-links", AppCreateAccountLinks)
  .component("app-password-strength", AppPasswordStrength)
  .use(ElementPlus)
  // Enable google analytics
  .use(VueGtag, {
    config: { id: "G-EHPYD80XK1" },
    appName: "Auth",
  })
  .mount("#app");
